module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-11.3847a6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Intel_em_Cybersecurity/Mobile_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-11.png
// module id = 192
// module chunks = 0